import { Redirect } from 'expo-router';
import React from 'react';

export default function TabsIndex() {
  return <Redirect href={{ pathname: '/(tabs)/activity' }} />;
}
